import "../RolePermissions/RolePermissions.css";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Grid2, InputBase, Paper } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  fetchAllSubscriptionsService,
  updateRoleSubscriptionService,
} from "../../../services/roleManagementService";
import { notifyError } from "../../../utilities/helper";
import Loader from "../../../components/Loader";
import CustomAPISwitch from "../../../components/CustomSwitch/CustomAPISwitch";
import { SearchSharp } from "@mui/icons-material";

const RoleSubscriptions = () => {
  const [load, setLoad] = useState(false);
  const [subscriptionsData, setSubscriptionsData] = useState(null);
  const [scrollToKey, setScrollToKey] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const subscriptionRefs = useRef({});

  const access_token = localStorage.getItem("access_token");

  const location = useLocation();
  const navigate = useNavigate();

  const roleId = location.state.id;

  useEffect(() => {
    if (roleId) {
      fetchSubscriptionsData(roleId);
    }
  }, [roleId]);

  // This is for scrolling to that section of the page whose data is updated
  useEffect(() => {
    if (scrollToKey && subscriptionRefs.current[scrollToKey]) {
      subscriptionRefs.current[scrollToKey]?.scrollIntoView({
        behavior: "smooth",
      });
      setScrollToKey(null);
    }
  }, [subscriptionsData]);

  const filterSubscriptionData = useMemo(() => {
    const lowerSearch = (searchTerm || "").toString().toLowerCase();

    if (!lowerSearch) return subscriptionsData;

    let result = [];

    const matchedSubscriptionData = subscriptionsData?.filter((subscription) =>
      subscription?.name?.toLowerCase().includes(lowerSearch)
    );

    if (matchedSubscriptionData.length > 0) {
      result = matchedSubscriptionData;
    }

    return result;
  }, [subscriptionsData, searchTerm]);

  const fetchSubscriptionsData = async (id) => {
    let res = null;
    setLoad(true);
    try {
      res = await fetchAllSubscriptionsService(id, access_token);
      if (res?.status === 200) {
        setSubscriptionsData(res?.data?.result?.allEmailContentData);
        setLoad(false);
      } else {
        notifyError("Failed to fetch subscriptions data");
        setLoad(false);
      }
    } catch (err) {
      console.log(err);
      setLoad(false);
      notifyError("Failed to fetch subscriptions data");
      if (err.status === 401) {
        navigate("/unauthorize");
      }
    }
  };

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="content-body">
          <p
            className="bread-crumbs-link-container"
            style={{ fontWeight: "600" }}
          >
            <Link className="bread-crumbs-link" to="/">
              Home
            </Link>{" "}
            |{" "}
            <Link className="bread-crumbs-link" to="/role-management">
              Role Management
            </Link>{" "}
            |{" "}
            <Link
              className="bread-crumbs-link"
              to="/role-subscriptions"
              state={{ id: roleId }}
            >
              Manage Role Subscriptions
            </Link>
            -{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>

          <Grid2
            container
            alignItems="start"
            sx={{ width: "100%", margin: "0 auto" }}
          >
            <Grid2 item md={12} sx={{ marginTop: "1%", marginBottom: "1%" }}>
              <Paper className="search-bar-conatiner">
                <SearchSharp style={{ width: 20, height: 20 }} />
                <InputBase
                  sx={{ ml: 1, flex: 1, fontSize: 16 }}
                  value={searchTerm}
                  placeholder={`Search Subscriptions`}
                  inputProps={{ "aria-label": `search subscriptions` }}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Paper>
            </Grid2>
          </Grid2>

          <div className="permission-container" style={{ marginTop: "2%" }}>
            {filterSubscriptionData && filterSubscriptionData?.length > 0 ? (
              <>
                <div className="permission-heading-container">
                  <span className="permission-heading">Genesis</span>
                </div>
                {filterSubscriptionData &&
                  filterSubscriptionData?.map((subscription, index) => (
                    <Grid2
                      key={index}
                      container
                      ref={(el) =>
                        (subscriptionRefs.current[subscription.id] = el)
                      }
                      justifyContent="space-between"
                      alignItems={"center"}
                      sx={{
                        width: "100%",
                        padding: "10px",
                        borderBottom: "1px solid #ccc",
                        ":hover": { backgroundColor: "#f5f5f5" },
                      }}
                    >
                      <Grid2 size={{ lg: 11, md: 11, xl: 11, sm: 11 }}>
                        <span>{subscription?.name}</span>
                      </Grid2>
                      <Grid2 size={{ lg: 1, md: 1, xl: 1, sm: 1 }}>
                        <CustomAPISwitch
                          isSwitch={subscription?.associatedToUser}
                          api={updateRoleSubscriptionService}
                          data={{
                            roleId: roleId,
                            subscriptionId: subscription?.id,
                            add: !subscription?.associatedToUser,
                          }}
                          onScrollKey={() => setScrollToKey(subscription.id)}
                          fetchOriginalData={fetchSubscriptionsData}
                          roleId={roleId}
                        />
                      </Grid2>
                    </Grid2>
                  ))}
              </>
            ) : (
              <div className="search-fallback-container">
                <span>No Subscriptions Found</span>
              </div>
            )}
          </div>

          <Grid2
            alignItems={"end"}
            justifyContent="end"
            container
            sx={{ marginTop: "2%" }}
          >
            <Grid2 item md={6}>
              <button
                className="create-btn"
                onClick={() => {
                  navigate("/role-management");
                }}
              >
                Back
              </button>
            </Grid2>
          </Grid2>
        </div>
      )}
    </>
  );
};

export default RoleSubscriptions;
